/* Rebuilds the supplier's product description into the Vox specification block.
 *
 * Tapstitch writes every description as nine flat "Label: Value" divs followed
 * by an eleven column size table. Dropped into the buy column as-is it runs off
 * the page, and no amount of CSS fixes eleven columns inside 46 characters.
 *
 * So this reads the description, sorts it into specification / features / care /
 * notes / size table, and rewrites it as a full width section below the product.
 * Everything is guarded: if the shape isn't what's expected the original markup
 * is left exactly where it was, styled by the fallback rules in vox-product.css.
 */
(function () {
  'use strict';

  var CARE_SPLIT = /\s*;\s*/;
  var LIST_SPLIT = /\s*,\s*/;

  function clean(s) {
    return (s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* The supplier ships the table with inline style, width, border and bgcolor
     attributes on nearly every cell. They paint alternating grey columns and
     pin the table to a fixed pixel width, both of which fight every rule in
     vox-product.css. Nothing in them is worth keeping. */
  function strip(table) {
    var nodes = [table].concat(Array.prototype.slice.call(table.querySelectorAll('*')));
    nodes.forEach(function (n) {
      ['style', 'width', 'height', 'bgcolor', 'border', 'cellpadding',
       'cellspacing', 'align', 'valign', 'class'].forEach(function (attr) {
        n.removeAttribute(attr);
      });
    });
  }

  /* Two header rows come through as plain <td> inside <tbody>: the sizes, then
     inch/cm under each. Promote both so they can be styled and stay put. */
  function promoteHeader(table) {
    var body = table.tBodies[0];
    if (!body || table.tHead || body.rows.length < 3) return;
    var head = table.createTHead();
    head.appendChild(body.rows[0]);
    var second = body.rows[0];
    if (second && clean(second.cells[1] && second.cells[1].textContent).toLowerCase() === 'inch') {
      head.appendChild(second);
    }
  }

  function parse(root) {
    var found = {
      specs: [],
      features: null,
      care: null,
      notes: null,
      lead: [],
      table: null
    };

    Array.prototype.slice.call(root.children).forEach(function (node) {
      if (node.tagName === 'TABLE') {
        found.table = node;
        return;
      }
      var nested = node.querySelector && node.querySelector('table');
      if (nested) {
        found.table = nested;
        return;
      }

      var txt = clean(node.textContent);
      if (!txt) return;

      var i = txt.indexOf(':');
      if (i < 1 || i > 26) {
        found.lead.push(txt);
        return;
      }

      var label = txt.slice(0, i).trim();
      var value = txt.slice(i + 1).trim();
      var key = label.toLowerCase();

      if (key.indexOf('care') === 0) found.care = value;
      else if (key.indexOf('note') === 0) found.notes = value;
      else if (key.indexOf('feature') === 0) found.features = value;
      else found.specs.push([label, value]);
    });

    return found;
  }

  function build(data) {
    var section = el('section', 'vox-pdp-detail');
    var grid = el('div', 'vox-pdp-detail__grid');

    /* column one: the heading, plus whatever prose the supplier wrote */
    var intro = el('div');
    intro.appendChild(el('h2', null, 'The detail'));
    data.lead.forEach(function (p) {
      var para = el('p', null, p);
      para.style.marginTop = '14px';
      para.style.fontSize = '14px';
      para.style.lineHeight = '1.65';
      intro.appendChild(para);
    });
    grid.appendChild(intro);

    /* column two: specification */
    if (data.specs.length) {
      var col = el('div');
      col.appendChild(el('h3', null, 'Specification'));
      var dl = el('dl', 'vox-spec');
      data.specs.forEach(function (pair) {
        var row = el('div');
        row.appendChild(el('dt', null, pair[0]));
        row.appendChild(el('dd', null, pair[1]));
        dl.appendChild(row);
      });
      col.appendChild(dl);
      grid.appendChild(col);
    }

    /* column three: care, then features */
    var third = el('div');
    var thirdUsed = false;

    if (data.care) {
      third.appendChild(el('h3', null, 'Care'));
      var ul = el('ul', 'vox-care');
      data.care.split(CARE_SPLIT).forEach(function (line) {
        line = clean(line);
        if (line) ul.appendChild(el('li', null, line));
      });
      third.appendChild(ul);
      thirdUsed = true;
    }

    if (data.features) {
      var h = el('h3', null, 'Made for');
      h.style.marginTop = thirdUsed ? '30px' : '0';
      third.appendChild(h);
      var chips = el('ul', 'vox-chips');
      data.features.split(LIST_SPLIT).forEach(function (f) {
        f = clean(f);
        if (f) chips.appendChild(el('li', null, f));
      });
      third.appendChild(chips);
      thirdUsed = true;
    }

    if (thirdUsed) grid.appendChild(third);
    section.appendChild(grid);

    if (data.notes) section.appendChild(el('p', 'vox-note', data.notes));

    if (data.table) {
      strip(data.table);
      promoteHeader(data.table);
      var details = el('details', 'vox-size');
      details.appendChild(el('summary', null, 'Size guide'));
      var hint = el('p', 'vox-size__hint',
        'Garment measurements, laid flat. Allow 1–2 cm for batch variation.');
      details.appendChild(hint);
      var scroll = el('div', 'vox-size__scroll');
      scroll.appendChild(data.table);
      details.appendChild(scroll);
      section.appendChild(details);
    }

    return section;
  }

  function enhance() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.voxRebuilt) return;

    /* the grid this sits beside, and the wrapper both columns share */
    var product = desc.closest('.product');
    var host = product && product.parentNode;
    if (!host) return;

    var data = parse(desc);
    if (!data.specs.length && !data.table) return; /* not the shape we expect */

    desc.dataset.voxRebuilt = '1';
    host.appendChild(build(data));
    desc.remove();
  }

  /* Mirror the chosen size next to its label, so the buy column still reads as
     a summary once the description has moved out of it. */
  function reflectChoice() {
    document.querySelectorAll('.product-form__input--pill').forEach(function (field) {
      var legend = field.querySelector('.form__label');
      if (!legend) return;
      var out = legend.querySelector('.vox-chosen');
      if (!out) {
        out = el('span', 'vox-chosen');
        legend.appendChild(out);
      }
      var checked = field.querySelector('input[type="radio"]:checked');
      out.textContent = checked ? checked.value : '';
    });
  }

  function init() {
    enhance();
    reflectChoice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') reflectChoice();
  });
})();
